import React from 'react';
import './Navbar.css'
import Logo from '../../Assets/Logo.svg'
import Navbtns from '../Common/Navbtns';

const Navbar = () => {
    return ( 
        <header>
            <img src={Logo} alt="" />
            <Navbtns />
        </header>
     );
}
 
export default Navbar;